(() => {
  if (window.__HausielSimpleCartOffersV11) return;
  window.__HausielSimpleCartOffersV11 = true;

  const SHIPPING_THRESHOLD = 64900;
  const DEFAULT_OFFER_THRESHOLD = 150000;
  const DEFAULT_MAX_ITEMS = 2;
  const OFFER_PREFIX = 'HAUSIEL Sepete Özel';
  const ORDER_MAX = 10;
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const rootRoute = () => window.Shopify?.routes?.root || '/';
  const threshold = () => Number(window.HausielUpsell?.cartOfferThreshold || DEFAULT_OFFER_THRESHOLD);
  const maxItems = () => Number(window.HausielUpsell?.cartOfferMaxItems || DEFAULT_MAX_ITEMS);
  const rateFor = (product) => {
    const rate = Number(window.HausielUpsell?.cartOfferRates?.[String(product?.id || '')]);
    return Number.isFinite(rate) && rate > 0 && rate < 100 ? rate : 0;
  };

  const merchSubtotal = (cart) => {
    let total = 0;
    let found = false;
    (cart?.items || []).forEach((item) => {
      const line = Number(item?.final_line_price ?? item?.original_line_price);
      if (Number.isFinite(line)) { total += line; found = true; }
      (item?.discount_allocations || []).forEach((allocation) => {
        const title = String(allocation?.discount_application?.title || '');
        const amount = Number(allocation?.amount || 0);
        if (title.startsWith(OFFER_PREFIX) && Number.isFinite(amount)) total += amount;
      });
    });
    if (found) return total;
    const explicit = Number(cart?.items_subtotal_price);
    return Number.isFinite(explicit) ? explicit : 0;
  };

  const freshCart = async (drawer, attempt = 0) => {
    const response = await fetch(`${rootRoute()}cart.js?hausiel_simple_offer=${Date.now()}_${attempt}`, {
      credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json', 'Cache-Control': 'no-cache', 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!response.ok) throw new Error('Sepet durumu alınamadı.');
    const cart = await response.json();
    const renderedHasItems = Boolean(drawer?.querySelector('#CartDrawer-CartItems .cart-item'));
    const expectedVariantId = String(drawer?.productId || '');
    const hasExpectedVariant = !expectedVariantId || (cart?.items || []).some((item) => String(item?.variant_id || item?.id || '') === expectedVariantId);
    if (renderedHasItems && (!Number(cart?.item_count || 0) || !hasExpectedVariant) && attempt < 2) {
      await sleep(80 * (attempt + 1));
      return freshCart(drawer, attempt + 1);
    }
    return cart;
  };

  customElements.whenDefined('cart-drawer').then(() => {
    const CartDrawerElement = customElements.get('cart-drawer');
    const proto = CartDrawerElement?.prototype;
    if (!proto || proto.__hausielSimpleOffersPatchedV11) return;
    proto.__hausielSimpleOffersPatchedV11 = true;

    proto.renderUpsell = function (cart, _legacySubtotal, slot, products, generation) {
      if (!slot?.isConnected || generation !== this.hausielGeneration) return;
      const map = new Map((products || []).map((product) => [String(product.id), product]));
      const cartIds = new Set((cart?.items || []).map((item) => String(item.product_id)));
      const lineQty = (variantId) => (cart?.items || [])
        .filter((item) => String(item?.variant_id || item?.id || '') === String(variantId))
        .reduce((sum, item) => sum + Number(item?.quantity || 0), 0);
      const dealsHtml = window.hzCartDeals ? window.hzCartDeals.html(cart, { head: false }) : '';
      const filters = (products || [])
        .filter((product) => rateFor(product) > 0 && !cartIds.has(String(product.id)))
        .filter((product) => (product.variants || []).some((v) => v.available !== false))
        .slice(0, 3);

      let panel = slot.querySelector('[data-hausiel-drawer-upsell]');
      if (!dealsHtml && !filters.length) { panel?.remove(); return; }
      if (!panel) {
        panel = document.createElement('div');
        panel.className = 'hdu';
        panel.setAttribute('data-hausiel-drawer-upsell', '');
        slot.appendChild(panel);
      }

      const tl = (c) => { const v = Number(c || 0) / 100; return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: Number.isInteger(v) ? 0 : 2, maximumFractionDigits: 2 }).format(v) + ' TL'; };
      const row = (o) => `<div class="hdu__row" data-hausiel-drawer-upsell-card>${o.img ? `<img class="hdu__img" src="${this.esc(o.img)}" alt="" loading="lazy">` : '<span class="hdu__img"></span>'}<div class="hdu__txt"><a class="hdu__title" href="${this.esc(o.url || '#')}">${this.esc(o.title)}</a>${(o.sub || []).map((l) => `<span class="hdu__sub">${this.esc(l)}</span>`).join('')}<span class="hdu__price">${o.upgrade && !o.price ? '<strong>Ek ücret yok</strong>' : `${o.was && o.was > o.price ? `<s>${tl(o.was)}</s> ` : ''}${o.upgrade ? `${this.esc(o.diffLabel)}: ` : ''}<strong>${tl(o.price)}</strong>`}</span>${o.upgrade ? '<span class="hdu__note">Paket fiyatı sepette otomatik uygulanır</span>' : ''}<p class="hdu__err" role="alert" data-hausiel-drawer-upsell-error hidden></p></div><button type="button" class="hdu__btn" data-hdu-add='${this.esc(JSON.stringify(o.items))}'${o.swapLine ? ` data-hdu-swap-key="${this.esc(o.swapLine.key)}" data-hdu-swap-qty="${Number(o.swapLine.quantity || 1) - 1}"` : ''}>${o.upgrade ? 'Yükselt' : 'Ekle'}</button></div>`;

      let html = '<p class="hdu__eyebrow">SEPETİNİZE EKLEYİN</p>' + dealsHtml;
      if (filters.length) {
        html += '<p class="hdu__label">Yedek filtreler %20 indirimli</p>';
        filters.forEach((product) => {
          const variant = product.variants.find((v) => v.available !== false) || product.variants[0];
          const rawImage = product.images?.[0] || product.image;
          const image = typeof rawImage === 'string' ? rawImage : rawImage?.src || '';
          const price = Math.round(parseFloat(variant.price || '0') * 100);
          const rate = rateFor(product);
          html += row({ title: product.title, url: `/products/${product.handle}`, img: image, was: price, price: Math.round(price * (1 - rate / 100)), items: [{ id: Number(variant.id), quantity: 1 }] });
        });
      }
      panel.innerHTML = html;
      if (dealsHtml && window.hzCartDeals) window.hzCartDeals.bind(panel, {
        sections: () => ({ sections: this.getSectionsToRender().map((section) => section.id), sections_url: `${window.location.pathname}${window.location.search}` }),
        done: (data) => {
          if (data && data.sections) {
            this.renderContents(data);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hausiel-cart-deals', cartData: data });
            requestAnimationFrame(() => this.scheduleHausielUpdate?.());
          } else window.location.assign(window.routes?.cart_url || `${rootRoute()}cart`);
        },
      });

      panel.querySelectorAll('[data-hdu-add]').forEach((button) => button.addEventListener('click', async () => {
        if (button.disabled) return;
        let items;
        try { items = JSON.parse(button.dataset.hduAdd); } catch (e) { return; }
        const errorBox = button.closest('[data-hausiel-drawer-upsell-card]')?.querySelector('[data-hausiel-drawer-upsell-error]');
        if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
        const old = button.textContent;
        button.disabled = true; button.textContent = '…';
        try {
          const sectionIds = this.getSectionsToRender().map((section) => section.id);
          const sectionsUrl = `${window.location.pathname}${window.location.search}`;
          const swapKey = button.dataset.hduSwapKey || '';
          const payload = swapKey ? { items } : { items, sections: sectionIds, sections_url: sectionsUrl };
          const response = await fetch(window.routes?.cart_add_url || `${rootRoute()}cart/add.js`, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(payload),
          });
          let data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');
          if (swapKey) {
            // 5 yedekli başlık, pakete dahil olan 10 yedekli başlıkla değiştirilir (önce ekleme, sonra eskisinin çıkarılması).
            const changeResponse = await fetch(`${rootRoute()}cart/change.js`, {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ id: swapKey, quantity: Math.max(0, Number(button.dataset.hduSwapQty || 0)), sections: sectionIds, sections_url: sectionsUrl }),
            });
            data = await changeResponse.json();
            if (!changeResponse.ok || data.status) throw new Error(data.description || data.message || 'Paket eklendi; 5 yedekli başlığı sepetten kendiniz çıkarabilirsiniz.');
          }
          if (data.sections) {
            this.renderContents(data);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hausiel-drawer-upsell', cartData: data });
            requestAnimationFrame(() => this.scheduleHausielUpdate?.());
          } else window.location.assign(window.routes?.cart_url || `${rootRoute()}cart`);
        } catch (error) {
          if (errorBox) { errorBox.hidden = false; errorBox.textContent = error?.message || 'Ürün sepete eklenemedi. Lütfen tekrar deneyin.'; }
          button.disabled = false; button.textContent = old;
        }
      }));
    };

    proto.updateHausielMerch = function () {
      this.ensureHausielEnhancements();
      const slot = this.merchSlot();
      if (!slot) return;
      const generation = ++this.hausielGeneration;

      Promise.all([freshCart(this), this.loadProducts()]).then(([cart, products]) => {
        if (generation !== this.hausielGeneration || !slot.isConnected) return;
        this.hausielMerchFailureRetries = 0;
        let progress = slot.querySelector('[data-hausiel-cart-progress]');
        if (!cart?.item_count) {
          progress?.remove(); slot.querySelector('[data-hausiel-drawer-upsell]')?.remove(); return;
        }
        if (!progress) {
          progress = document.createElement('div'); progress.className = 'hausiel-cart-progress';
          progress.setAttribute('data-hausiel-cart-progress', ''); slot.prepend(progress);
        }

        const shippingTotal = Number(cart.total_price || 0);
        const left = Math.max(0, SHIPPING_THRESHOLD - shippingTotal);
        const pct = Math.min(100, shippingTotal / SHIPPING_THRESHOLD * 100);
        const title = left ? `Ücretsiz kargoya ${this.money(left)} kaldı` : 'Ücretsiz kargo aktif';
        const detail = left ? '649 TL ve üzeri siparişlerde ücretsiz kargo' : '649 TL eşiğine ulaştınız';
        progress.innerHTML = `<div class="hausiel-cart-progress__row"><div class="hausiel-cart-progress__label"><strong>${title}</strong><span>${detail}</span></div><div class="hausiel-cart-progress__track" aria-hidden="true"><span class="hausiel-cart-progress__fill" style="width:${pct}%"></span></div></div>`;
        this.renderUpsell(cart, merchSubtotal(cart), slot, products, generation);
      }).catch(() => {
        if (generation !== this.hausielGeneration || !slot.isConnected) return;
        clearTimeout(this.hausielMerchRetryTimer);
        if (Number(this.hausielMerchFailureRetries || 0) < 1) {
          this.hausielMerchFailureRetries = Number(this.hausielMerchFailureRetries || 0) + 1;
          this.hausielMerchRetryTimer = setTimeout(() => {
            if (this.isConnected && !this.classList.contains('is-empty')) this.scheduleHausielUpdate?.();
          }, 220);
        }
      });
    };
  });
})();
